// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1QRO0","title":"FrontImage_title__1D4vy"};